namespace Areas.Analysis.TimesheetPivot {
    "use strict";

    let startDate: Date;
    let endDate: Date;
    let runQuery: boolean = false;


    export function canExecuteQuery() {
        return runQuery;
    }


    export function onCellPrepared(e: any) {
        if (e.area === "row" && e.cell.path) {
            if (e.cell.text.includes('href')) {
                var linkText = e.cell.text;
                if (e.cell.path.length > 1) {
                    e.cellElement.html(linkText)
                } else {
                    var piStart = linkText.indexOf(">") + 1;
                    var piLength = linkText.length - 4;
                    var projectInfoText = linkText.substring(piStart, piLength);
                    return e.cellElement.text(projectInfoText);
                }
            }
        }
    }

    export function selectorLink(data: any) {
        var projectInfo = data.projectNumber + "--" + data.projectName;
        var linkInfo = "<a href='/Account/Profile/View/" +
            data.accountId +
            "'  target=_blank>" + projectInfo + "</a>";
        return linkInfo;

    }


    export function resetPivotGrid() {
        const dataPivot = $("#TimesheetPivotGrid").dxPivotGrid("instance");
        dataPivot.getDataSource().state({});
    }

    export function refreshData() {
        const form = $("#TimePeriodSelectForm").dxForm("instance");
        const formData: any = form.option("formData");

        if ((formData.startDate == null) || (formData.endDate == null)) {
            DevExpress.ui.notify("You need to select a time period first!", "warning", 2000);
            return;
        }

        startDate = formData.startDate;
        endDate = formData.endDate;
        runQuery = true;

        const dataPivot = $("#TimesheetPivotGrid").dxPivotGrid("instance");
        dataPivot.getDataSource().reload();

        const dataGrid = $("#TimesheetGrid").dxDataGrid("instance");
        dataGrid.refresh();

    }

    export function getStartDate() {
        return startDate;
    }

    export function getEndDate() {
        return endDate;
    }

    export function goToProjectFromGrid(e: any) {
        const dataGrid = $("#TimesheetGrid").dxDataGrid("instance");
        const rows = dataGrid.getSelectedRowsData();
        if (rows.length == 1) {
            location.href = "/Account/Profile/View/" + rows[0].accountId; // + " target=_blank ";
        }
        else {
            DevExpress.ui.notify("You need to select a row first!", "warning", 2000);
        }

    }

    export function getStartEndDateFromTimePeriod(e) {
        const form = $("#TimePeriodSelectForm").dxForm("instance");
        const formData: any = form.option("formData");

        if (e.selectedItem == null) {
            const timePeriodText = null
            formData.startDate = null;
            formData.endDate = null;
            form.option("formData", formData);

        } else {

            const timePeriodText = e.selectedItem.id;

            $.get(`/Analysis/TimesheetPivot/GetStartEndDates/${timePeriodText}`,
                (data) => {

                    startDate = data.beginDate;
                    endDate = data.endDate;

                    formData.startDate = data.beginDate;
                    formData.endDate = data.endDate;
                    form.option("formData", formData);

                });

        }

    }

}